import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import ErrorContext from './ErrorContext';
import ErrorMessage from './ErrorMessage';
import type { ErrorType } from './types';

type ErrorContainerProps = {
  children: React.ReactNode;
};

type ErrorParams = {
  message: string;
  error?: ErrorType;
};

type ErrorStateProps = {
  show: boolean;
  message: string;
  error?: ErrorType;
  closeTimer?: void | null | ReturnType<typeof setTimeout>;
};
const ErrorContainer = (props: ErrorContainerProps) => {
  const intl = useIntl();
  const [errorState, setErrorState] = useState<ErrorStateProps>({
    show: false,
    message: '',
    error: undefined,
    closeTimer: null,
  });

  const showError: any = ({ message, error }: ErrorParams) => {
    setErrorState({
      show: Boolean(message),
      message: message ? intl.formatMessage({ id: message }) : '',
      error,
      closeTimer: setTimeout(() => hideError(), 3000),
    });
  };

  const hideError = () => {
    setErrorState({
      show: false,
      message: '',
      error: undefined,
      closeTimer: errorState.closeTimer
        ? clearTimeout(errorState.closeTimer)
        : null,
    });
  };

  return (
    <ErrorContext.Provider
      value={{
        ...errorState,
        showError,
      }}
    >
      <ErrorMessage onClick={hideError} />
      {props.children}
    </ErrorContext.Provider>
  );
};

export default ErrorContainer;
